import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { API_S3_BASE_URL } from '../../apiConstant';

export const useViewS3FileById = () => {
  return useMutation({
    mutationFn: async (fileId) => {
      const res = await axios.get(`${API_S3_BASE_URL}/api/s3/view-cdn-by-id`, {
        params: { id: fileId },
      });
      return res.data; // signed / CDN URL
    },
  });
};
